import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {HelpfulInformationRoutingModule} from './helpful-information-routing.module';
import {AboutUsComponent} from './about-us/about-us.component';
import {CharityEffortsComponent} from './charity-efforts/charity-efforts.component';
import {ContactUsComponent} from './contact-us/contact-us.component';
import {PortersPageComponent} from './porters-page/porters-page.component';
import {PrivacyPolicyComponent} from './privacy-policy/privacy-policy.component';
import {RefundPageComponent} from './refund-page/refund-page.component';
import {TermsPageComponent} from './terms-page/terms-page.component';
import {TippingGuideComponent} from './tipping-guide/tipping-guide.component';
import {BookingAndRatesComponent} from './booking-and-rates/booking-and-rates.component';
import {WidgetsModule} from '../widgets-module/widgets.module';
import {DirectivesModule} from '../directives-module/directives.module';
import {GuidesPageComponent} from "./guides-page/guides-page.component";
import {NgxTypedJsModule} from "ngx-typed-js";
import {TabsModule} from 'ngx-bootstrap/tabs';
import {IvyCarouselModule} from 'angular-responsive-carousel';
import {ReviewsComponent} from './reviews/reviews.component';
import {BookableRowEntryComponent} from './bookable-row-entry/bookable-row-entry.component';
import {HelpersModule} from "../helpers-module/helpers.module";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";

@NgModule({
  declarations: [
      AboutUsComponent,
      CharityEffortsComponent,
      ContactUsComponent,
      PortersPageComponent,
      PrivacyPolicyComponent,
      RefundPageComponent,
      TermsPageComponent,
      TippingGuideComponent,
      BookingAndRatesComponent,
      GuidesPageComponent,
      ReviewsComponent,
      BookableRowEntryComponent
  ],
  imports: [
    CommonModule,
    HelpfulInformationRoutingModule,
    WidgetsModule,
    DirectivesModule,
    NgxTypedJsModule,
    IvyCarouselModule,
    TabsModule.forRoot(),
    HelpersModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class HelpfulInformationModule { }
